import { useEffect, useState } from "react";

import { SalesChannel, getSalesChannels } from "../../../../lib/shopifyInfo";

type SalesChannelsState = {
    channels: SalesChannel[];
    isLoading: boolean;
    error: boolean;
};

/**
 * Reads the store's sales channels from Shopify.
 */
export function useSalesChannels(storeId: number, enabled: boolean): SalesChannelsState {
    const [channels, setChannels] = useState<SalesChannel[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!enabled) return;

        let hasUnmounted = false;
        setIsLoading(true);

        getSalesChannels(storeId)
            .then((result) => {
                if (hasUnmounted) return;
                setChannels(result);
                setError(false);
            })
            .catch(() => {
                if (!hasUnmounted) setError(true);
            })
            .finally(() => {
                if (!hasUnmounted) setIsLoading(false);
            });

        return () => {
            hasUnmounted = true;
        };
    }, [storeId, enabled]);

    return { channels, isLoading, error };
}
